export class LocationDesk {

    internalId: string;
    name: string;
    numeration: string;
    status: string;
    turnAlias: string;
    turnDeskName: string;
    customerName: string;

    constructor(internalId?: string, name?: string, numeration?: string, status?: string, turnAlias?: string, turnDeskName?: string, customerName?: string) {
        this.internalId = internalId;
        this.name = name;
        this.numeration = numeration;
        this.status = status;
        this.turnAlias = turnAlias;
        this.turnDeskName = turnDeskName;
        this.customerName = customerName;
    }

    public get InternalId(): string {
        return this.internalId;
    }
    public set InternalId(value: string) {
      this.internalId = value;
    }
    public get Name(): string {
        return this.name;
    }
    public set Name(value: string) {
      this.name = value;
    }
    public get Numeration(): string {
        return this.numeration;
    }
    public set Numeration(value: string) {
      this.numeration = value;
    }
    public get Status(): string {
        return this.status;
    }
    public set Status(value: string) {
        this.status = value;
    }
    public get TurnAlias(): string {
        return this.turnAlias;
    }
    public set TurnAlias(value: string) {
        this.turnAlias = value;
    }
    public get TurnDeskName(): string {
        return this.turnDeskName;
    }
    public set TurnDeskName(value: string) {
        this.turnDeskName = value;
    }
    public get CustomerName(): string {
        return this.customerName;
    }
    public set CustomerName(value: string) {
        this.customerName = value;
    }
}
